<template>
  <div class="app-wrapper">
    <el-container>
      <el-aside width="162px">
        <index-user-info :user-info="userInfo"></index-user-info>
        <site-menu :user-info="userInfo"></site-menu>
        <download-menu></download-menu>
      </el-aside>
      <el-container>
        <el-header style="height: 97px">
          <index-header></index-header>
          <!-- 面包屑 -->
          <breadcrumb />
        </el-header>
        <el-main class="app-main">
          <transition name="fade">
          <router-view
            :org-id="userInfo.origanization"
            :user-info="userInfo" />
          </transition>
        </el-main>
        <el-footer class="footer" style="height: 32px;">
          <span>2020©版权所有&nbsp;&nbsp;深圳市海云天科技股份有限公司&nbsp;&nbsp;
            <a style="color: #685f26; text-decoration: unset;" href="http://beian.miit.gov.cn" target="_blank" class="footer-word">粤ICP备13057678号</a>
            <!-- 粤ICP备13057678号-4 -->
          </span>
        </el-footer>
      </el-container>
    </el-container>
    <user-edit
      :warmTips="warmTips"
      :forceEditPassword="true"
      :editUserFlag="false"
      :user-info="userInfo"
      :visible="userEditVisible"
      @user-edit-close="editClose">
    </user-edit>
    <account-alert :visible="open" :status='userInfo.status' :title='title' @close='handleClose'></account-alert>
    <customer-service-dialog v-if="userInfo.organization.costType !== '0'"></customer-service-dialog>
  </div>
</template>

<script>
import common from '@/util/common'
import IndexHeader from './IndexHeader'
import IndexUserInfo from './IndexUserInfo'
import SiteMenu from './SiteMenu'
import DownloadMenu from './DownloadMenu'
import MenuList from './MenuList'
import Breadcrumb from './Breadcrumb'
import { getUserInfo, getCurrentUserInfo } from '@/model/user-model'
import { IndexRedirect } from '@/components/mixins/InfoSource'
import AccountAlert from '@/components/custom/AccountAlert'
import UserEdit from '../user/UserEdit'
import customerServiceDialog from './customerServiceDialog'

export default {
  name: 'Index',
  data () {
    return {
      open: false,
      title: '',
      userEditVisible: false,
      warmTips: '',
      unCheckPasswordUrl: [
        '10.8.116.123',
        '127.0.0.1'
      ]
    }
  },
  mixins: [IndexRedirect],
  computed: {
    userInfo () {
      return common.getUserInfo()
    },
    userPosition () {
      return this.$store.getters.userSchoolPosition
    }
  },
  components: {
    IndexHeader,
    IndexUserInfo,
    SiteMenu,
    DownloadMenu,
    MenuList,
    Breadcrumb,
    AccountAlert,
    UserEdit,
    customerServiceDialog
  },
  methods: {
    menuRouterTo (url) {
      this.$router.push(url)
    },
    checkPassword (isShenzhenUser) {
      let isDefaultPassword = sessionStorage.getItem('default_key')
      console.log(isDefaultPassword)
      getCurrentUserInfo().then(res => {
        let isWeakPassword = sessionStorage.getItem('weakPassword')
        let todayTimeTamp = new Date().getTime()
        let intervalDay = Math.ceil((todayTimeTamp - res.pwdLastUpdateTime) / 86400000)
        if (intervalDay > 90 && isShenzhenUser) {
          this.warmTips = '您的密码已超过3个月未修改,请修改密码后使用!'
          this.userEditVisible = true
        } else if (isWeakPassword === 'true') {
          this.warmTips = '您的密码强度太弱,请修改密码后使用!'
          this.userEditVisible = true
        } else {
          this.showNotice()
        }
      }, () => {
        this.showNotice()
      })
    },
    editClose () {
      this.userEditVisible = false
    },
    showNotice () {
      /*
      * 试用账户 在过期前  7 天给用户提醒  每次登陆提醒一次
      * 正式账户 在过期前 31 天给用户提醒  每次登陆提醒一次
      * 其他正式/试用 不是快过期的 每次登陆提醒一次
      * 过期账户 每次刷新都提醒
      */
      let expireDate = Date.parse(this.userInfo.organization.expireDate)
      let nowDate = Date.parse(new Date())
      let intervalDays = Math.ceil((expireDate - nowDate) / (1000 * 60 * 60 * 24))
      let expireDateStr = this.userInfo.organization.expireDate ? common.dateTimeFormat(this.userInfo.organization.expireDate.split(' ')[0], 'yyyy年MM月dd日') : ''
      if (intervalDays < 0) {
        this.title = `
          <div style='text-indent: 35px'>为客户提供优质产品及服务是我们永不懈怠的初心，在此温馨提醒您：</div>
          <div style='text-indent: 35px'>您的账号使用权限已过期，请及时通过以下方式之一联系我们进行续费.</div>
          <div style='text-indent: 35px'>联系销售人员 / 致电客服电话400-8811-099 转 4 / 登陆客户服务联系平台，登录官网 <a href='https://www.kaow.cn' target='blank'>https://www.kaow.cn</a>，点击界面右上角“在线咨询”图标咨询。</div>
          <div style='text-indent: 35px'>让我们携手共同促进本平台健康持续发展，感谢您的信赖和支持！</div>
        `
        this.open = true
      } else if (this.userInfo.organization.costType === '1' && intervalDays < 8) {
        this.title = `
          <div style='text-indent: 35px'>为客户提供优质产品及服务是我们永不懈怠的初心，在此温馨提醒您：</div>
          <div style='text-indent: 35px'>账号服务状态：您的账号在${expireDateStr}(${intervalDays}天后)即将到期，请及时续费以免影响使用。</div>
          <div style='text-indent: 35px'>可通过以下方式之一联系我们：</div>
          <div style='text-indent: 35px'>联系销售人员 / 致电客服电话400-8811-099 转 4 / 登陆客户服务联系平台，登录官网 <a href='https://www.kaow.cn' target='blank'>https://www.kaow.cn</a>，点击界面右上角“在线咨询”图标咨询。</div>
          <div style='text-indent: 35px'>让我们携手共同促进本平台健康持续发展，感谢您的信赖和支持！</div>
        `
        let showTipsFlag = sessionStorage.getItem('showTipsFlag')
        if (showTipsFlag === 'true') {
          this.open = true
          sessionStorage.setItem('showTipsFlag', 'false')
        }
      } else if (this.userInfo.organization.costType === '0' && intervalDays < 32) {
        this.title = `
          <div style='text-indent: 35px'>为客户提供优质产品及服务是我们永不懈怠的初心，在此温馨提醒您：</div>
          <div style='text-indent: 35px'>账号服务状态：您的账号在${expireDateStr}(${intervalDays}天后)即将到期，请及时续费以免影响使用。</div>
          <div style='text-indent: 35px'>可通过以下方式之一联系我们：</div>
          <div style='text-indent: 35px'>联系销售人员 / 致电客服电话400-8811-099 转 4 / 登陆客户服务联系平台，登录官网 <a href='https://www.kaow.cn' target='blank'>https://www.kaow.cn</a>，点击界面右上角“在线咨询”图标咨询。</div>
          <div style='text-indent: 35px'>让我们携手共同促进本平台健康持续发展，感谢您的信赖和支持！</div>
        `
        let showTipsFlag = sessionStorage.getItem('showTipsFlag')
        if (showTipsFlag === 'true') {
          this.open = true
          sessionStorage.setItem('showTipsFlag', 'false')
        }
      } else {
        this.title = `
          <div style='text-indent: 35px'>为客户提供优质产品及服务是我们永不懈怠的初心，在此温馨提醒您：</div>
          <div style='text-indent: 2em'>（1）账号服务状态：请在账号使用过程中，及时关注账号服务是否正常。</div>
          <div style='text-indent: 2em'>（2）资源服务限制：如遇到账号服务受限（包括未启用账号、未签订合同、未付款等情况），请及时通过以下方式之一联系我们：</div>
          <div style='text-indent: 35px'>联系销售人员 / 致电客服电话400-8811-099 转 4 / 登陆客户服务联系平台，登录官网 <a href='https://www.kaow.cn' target='blank'>https://www.kaow.cn</a>，点击界面右上角“在线咨询”图标咨询。</div>
          <div style='text-indent: 35px'>让我们携手共同促进本平台健康持续发展，感谢您的信赖和支持！</div>
        `
        let showTipsFlag = sessionStorage.getItem('showTipsFlag')
        if (showTipsFlag === 'true') {
          this.open = true
          sessionStorage.setItem('showTipsFlag', 'false')
        }
      }
    },
    handleClose () {
      this.open = false
    }
  },
  mounted () {
    let isShenzhenUser = this.userInfo.organization.area && this.userInfo.organization.area.includes('深圳')
    if (!this.unCheckPasswordUrl.includes(location.hostname)) {
      this.checkPassword(isShenzhenUser)
    }
    // 暂时针对深圳处理密码问题
    // if (this.userInfo.organization.area && this.userInfo.organization.area.includes('深圳') && !this.unCheckPasswordUrl.includes(location.hostname)) {
    //   this.checkPassword()
    // } else {
    //   this.showNotice()
    // }
  },
  beforeRouteEnter (to, from, next) {
    console.log('beforeRouteEnter')
    if (to.query.userId) {
      let userInfoTmpObject = {}
      getUserInfo({userId: to.query.userId}).then((userData) => {
        if (userData.result && userData.result.toString() === 'false') {
          userInfoTmpObject = {
            desc: '',
            email: '18888888888@kaow.com',
            icon: '',
            infoSources: 1,
            mobilePhone: '18888888888',
            name: '已过期',
            organization: {organizationId: '', name: '', address: '', userCnt: 0, city: '', libType: '1'},
            origanization: '',
            origanizationName: '已过期',
            positionList: [],
            qq: '',
            registerTime: '2022-06-13',
            role: '',
            status: 'timeOut',
            subjectName: '',
            userGrade: '',
            userId: to.query.userId
          }
        } else {
          userInfoTmpObject = {...userData}
        }
        sessionStorage.setItem('user_info', JSON.stringify(userInfoTmpObject))
        if (to.query.defaultKey) {
          sessionStorage.setItem('default_key', to.query.defaultKey)
        }
        // console.log(this.$store)
        console.log('userInfoLoaded')
        next()
      })
    } else {
      next()
    }
  },
  created () {
    let userInfoTmpObject = JSON.parse(sessionStorage.user_info)
    this.$store.dispatch('saveUserInfo', userInfoTmpObject)
    this.$store.dispatch('saveSchoolPosition', userInfoTmpObject.positionList)
    this.$store.dispatch('initCurrentPosition')
    console.log('index created')
    if (userInfoTmpObject.organization.costType === '0') {
      document.body.classList.add('hide-bottom-content')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.app-wrapper {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  .el-header{
    padding: 0;
  }
  .app-main{
    overflow: hidden;
    background: $color-main-background;
    padding: 30px 30px 30px 30px;
    height: calc(100vh - 32px - 97px);;
  }
  .footer {
    margin: 0 auto;
    color: #685f26;
    font-size: 12px;
    line-height: 32px;
    background: $color-main-background;
    width: 100%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/Index.vue